import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const DEFAULT_SAFE_OFFSET: NonNullable<ToasterProps["offset"]> = {
  top: "calc(var(--safe-area-top, 0px) + 12px)",
  right: 12,
  bottom: "calc(var(--safe-area-bottom, 0px) + 12px)",
  left: 12,
};

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const { offset, mobileOffset, ...rest } = props;

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      offset={offset ?? DEFAULT_SAFE_OFFSET}
      mobileOffset={mobileOffset ?? DEFAULT_SAFE_OFFSET}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...rest}
    />
  );
};

export { Toaster, toast };
